// extracted by mini-css-extract-plugin
export default {"footer":"CarouselFooter_footer__t2VRd","circle":"CarouselFooter_circle__C4FVD","filledCircle":"CarouselFooter_filledCircle__GmcVO"};